<template>
  <transition name="search-expand">
    <div v-show="expanded" :class="{ loaded: loaded }">
      <form ref="form" class="nav__search-form" :action="page">
        <input
          type="text"
          name="q"
          ref="input"
          @keydown="handleReverseTabKey"
          placeholder="Search"
          required
        />
        <button
          type="submit"
          ref="submit"
          @keydown="handleForwardTabKey"
          class="base-btn-primary base-btn-primary--light btn"
        >
          Search
        </button>
      </form>
    </div>
  </transition>
</template>

<script>
import eventBus from '@/js/util/eventBus'

export default {
  data() {
    return {
      expanded: false,
      loaded: false,
    }
  },
  props: {
    page: {
      type: String,
      default: '/search-results',
    },
  },
  methods: {
    toggleExpanded(expanded) {
      this.expanded = expanded
      this.$nextTick(function() {
        if (expanded) {
          this.focusFirst()
        }
      })
    },
    focusFirst() {
      this.$refs.input.focus()
    },
    focusLast() {
      this.$refs.submit.focus()
    },
    handleReverseTabKey(event) {
      if (this.expanded && event.key == 'Tab' && event.shiftKey) {
        event.preventDefault()
        event.stopPropagation()
        eventBus.$emit('nav:search:focus')
      }
    },
    handleForwardTabKey(event) {
      if (this.expanded && event.key == 'Tab' && !event.shiftKey) {
        event.preventDefault()
        eventBus.$emit('nav:search:focus')
      }
    },
  },
  mounted() {
    eventBus.$on('nav:search', this.toggleExpanded)
    eventBus.$on('nav:search:focus:first', this.focusFirst)
    eventBus.$on('nav:search:focus:last', this.focusLast)

    this.$nextTick(() => {
      this.loaded = true
    })
  },
}
</script>

<style lang="scss" scoped>
.search-expand-enter-active,
.search-expand-leave-active {
  transition: all 0.25s ease-in;
}

.search-expand-enter,
.search-expand-leave-to {
  transform: translateY(-25px);
  opacity: 0;
}
</style>
